import { render, staticRenderFns } from "./OccupationList.vue?vue&type=template&id=2f363d06&scoped=true"
import script from "./OccupationList.vue?vue&type=script&lang=js"
export * from "./OccupationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f363d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f363d06')) {
      api.createRecord('2f363d06', component.options)
    } else {
      api.reload('2f363d06', component.options)
    }
    module.hot.accept("./OccupationList.vue?vue&type=template&id=2f363d06&scoped=true", function () {
      api.rerender('2f363d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user/OccupationList.vue"
export default component.exports